import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles(theme => {
  return ({
    root: {
      maxWidth: "100%",
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  });
})
const PanelCard = ({selectedValue, handleChange, name, description, panel, inverter, optimizer, image, battery, wallbox}) => {
    const classes = useStyles();
    
    return <Card onClick={() => handleChange(panel, inverter, optimizer, image, battery, wallbox)} style={{borderWidth: selectedValue === panel ?  '1px' : '', borderStyle: selectedValue === panel ?  "solid" : ""}} className={classes.root}>
    <CardContent>
      <Typography variant="h4" gutterBottom>
        {name}
      </Typography>
      <Typography variant="h5" component="h2">
      </Typography>
      <Typography variant="body2" component="p">
        {description}
      </Typography>
    </CardContent>
  </Card>
}

export default PanelCard;